<template>
	<div class="box01">
		<v-crumbs :crumbsType='5'></v-crumbs>
		<div>
			<div class="form_wrapper">
				<div class="form_wrapper_left">
					<div class="form_wrapper_block">
						<div class="form_wrapper_title">
							<p></p>
							<p>基本信息</p>
						</div>
						<div class="info_wrapper">
							<div class="info_wrapper_block">
								<div class="form_input_wrapper">
									<p class="form_input_label">订单编号:</p>
									<div class="form_input">
										<el-input v-model="submit_info.order_no" readonly placeholder="保存时自动生成"></el-input>
									</div>
								</div>
							</div>
							<div class="info_wrapper_block">
								<div class="form_input_wrapper">
									<p class="form_input_label"><span class="c_ff6f6f">*</span>报价人员:</p>
									<div class="form_input">
										<el-input v-model="submit_info.bidder" placeholder="请填写报价人员"></el-input>
									</div>
								</div>
							</div>
							<div class="info_wrapper_block">
								<div class="form_input_wrapper">
									<p class="form_input_label"><span class="c_ff6f6f">*</span>报价有效期:</p>
									<div class="form_input">
										<el-date-picker v-model="submit_info.validity" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
									</div>
								</div>
							</div>
							<div class="info_wrapper_block">
								<div class="form_input_wrapper">
									<p class="form_input_label"><span class="c_ff6f6f">*</span>服务类型:</p>
									<div class="form_input">
										<v-select :icon_num="true" :list="serve_list" :value_name="submit_info.service_type_id_name" @result="get_serve_type"></v-select>
									</div>
								</div>
							</div>
							<div class="info_wrapper_block">
								<div class="form_input_wrapper">
									<p class="form_input_label"><span class="c_ff6f6f">*</span>销售人员:</p>
									<div class="form_input">
										<el-input v-model="submit_info.sales_person" placeholder="请填写销售人员"></el-input>
									</div>
								</div>
							</div>
							<div class="form_choose_wrapper">
								<p class="form_input_label"><span class="c_ff6f6f">*</span>服务范围:</p>
								<div class="form_choose_content" style="flex-wrap: wrap;">
									<div class="form_choose_block" :class="{'active': item.id == submit_info.services_scope_id}" v-for="(item, index) in services_scope_list">
										<i @click="submit_info.services_scope_id = item.id"></i>
										<p>{{item.name}}</p>
									</div>
								</div>
							</div>
							<div class="form_choose_wrapper">
								<p class="form_input_label"><span class="c_ff6f6f">*</span>运输方式:</p>
								<div class="form_choose_content" style="flex-wrap: wrap;">
									<div class="form_choose_block" :class="{'active': item.id == submit_info.transport_id}" v-for="(item, index) in transport_list">
										<i @click="submit_info.transport_id = item.id"></i>
										<p>{{item.name}}</p>
									</div>
								</div>
							</div>
							<div class="form_choose_wrapper">
								<p class="form_input_label"><span class="c_ff6f6f">*</span>运输流向:</p>
								<div class="form_choose_content" style="flex-wrap: wrap;">
									<div class="form_choose_block" :class="{'active': item.id == submit_info.transportation_id}" v-for="(item, index) in transportation_list">
										<i @click="submit_info.transportation_id = item.id"></i>
										<p>{{item.name}}</p>
									</div>
								</div>
							</div>
							<div class="info_wrapper_block">
								<div class="form_input_wrapper">
									<p class="form_input_label">航司/船司:</p>
									<div class="form_input">
										<v-select :list="company_list" :value_name="submit_info.shipping_company_name" :from="1" @result="get_ship"></v-select>
									</div>
								</div>
							</div>
							<div class="info_wrapper_block">
								<div class="form_input_wrapper">
									<p class="form_input_label">线路:</p>
									<div class="form_input">
										<v-select :icon_num="true" :list="luxian_list" :value_name="submit_info.circuit_id_name" @result="get_luxian"></v-select>
									</div>
								</div>
							</div>
							<div class="info_wrapper_block">
								<div class="form_input_wrapper">
									<p class="form_input_label">运单编号:</p>
									<div class="form_input w_510">
										<el-input v-model="submit_info.waybill_no" placeholder="请填写运单编号"></el-input>
									</div>
								</div>
							</div>
							<div class="info_wrapper_block">
								<div class="form_input_wrapper">
									<p class="form_input_label w_118"><span class="c_ff6f6f">*</span>起运地/起运港:</p>
									<div class="form_input w_480">
										<v-select :icon_num="true" :list="start_harbor_list" :value_name="submit_info.shipment_id_name" :from="2"
										 :service_type="submit_info.service_type_id" @result="get_harbor"></v-select>
									</div>
								</div>
							</div>
							<div class="info_wrapper_block">
								<div class="form_input_wrapper">
									<p class="form_input_label w_118"><span class="c_ff6f6f">*</span>目的地/目的港:</p>
									<div class="form_input w_480">
										<v-select :icon_num="true" :list="end_harbor_list" :value_name="submit_info.destination_id_name" :from="3"
										 :service_type="submit_info.service_type_id" @result="get_end_harbor"></v-select>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="form_wrapper_block">
						<div class="form_wrapper_title">
							<p></p>
							<p>货物信息</p>
						</div>
						<div class="form_table_wrapper">
							<div class="form_table_add">
								<div class="form_table_add_block">
									<img src="../../assets/04@2x.png" @click="get_add_huowu" />
									<p>新增一组</p>
								</div>
							</div>
							<div>
								<div class="form_table_list" v-for="(item, index) in huowu_list" :key="index">
									<div class="form_delete_icon">
										<i @click="get_del_huowu(index)"></i>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label"><span class="c_ff6f6f">*</span>件数:</p>
											<div class="form_input">
												<el-input v-model="item.cases" placeholder="请填写件数"></el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label"><span class="c_ff6f6f">*</span>包装:</p>
											<div class="form_input">
												<v-select :list="pack_list" :index="index" :value_name="item.pack" @result="get_pak"></v-select>
												<!-- <el-input v-model="item.pack" placeholder="请填写包装"></el-input> -->
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label"><span class="c_ff6f6f">*</span>毛重:</p>
											<div class="form_input">
												<el-input v-model="item.rough_weight" placeholder="请填写毛重"></el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label"><span class="c_ff6f6f">*</span>计重:</p>
											<div class="form_input" style="display: flex;align-items: center;">
												<el-input v-model="item.weight" placeholder="自动算出"></el-input>
												<p class="form_input_unit">KG</p>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label"><span class="c_ff6f6f"></span>长:</p>
											<div class="form_input">
												<el-input v-model="item.long" placeholder="请填写长度"></el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label"><span class="c_ff6f6f"></span>宽:</p>
											<div class="form_input">
												<el-input v-model="item.broad" placeholder="请填写宽度"></el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label"><span class="c_ff6f6f"></span>高:</p>
											<div class="form_input">
												<el-input v-model="item.tall" placeholder="请填写高度"></el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper dis">
											<p class="form_input_label"><span class="c_ff6f6f">*</span>体积:</p>
											<div class="form_input" style="display: flex;align-items: center;">
												<el-input v-model="item.bulk" placeholder="自动算出"></el-input>
												<p class="form_input_unit">CBM</p>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label"><span class="c_ff6f6f">*</span>中文品名:</p>
											<div class="form_input">
												<el-input v-model="item.chinese_name" placeholder="请填写中文品名"></el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label">英文品名:</p>
											<div class="form_input w_476">
												<el-input v-model="item.english_name" placeholder="请填写英文品名"></el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label"><span class="c_ff6f6f"></span>HS编码:</p>
											<div class="form_input">
												<v-select :list="hs_list" :index="index" :value_name="item.hs_code_name" :from="4" @result="get_hs"></v-select>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label"><span class="c_ff6f6f"></span>货值:</p>
											<div class="form_input">
												<el-input v-model="item.low_value" placeholder="请填写货值"></el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label"><span class="c_ff6f6f"></span>币制:</p>
											<div class="form_input">
												<v-select :list="currency_list" :index="index" :value_name="item.currency_system_name" @result="get_currency"></v-select>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label"><span class="c_ff6f6f">*</span>船名/航次:</p>
											<div class="form_input">
												<el-input v-model="item.flight_name" placeholder="请填写船名/航次"></el-input>
											</div>
										</div>
									</div>
									<div class="info_wrapper_block">
										<div class="form_input_wrapper">
											<p class="form_input_label"><span class="c_ff6f6f">*</span>起运时间:</p>
											<div class="form_input">
												<el-date-picker v-model="item.shipment_date" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="form_wrapper_block">
						<div class="form_wrapper_title">
							<p></p>
							<p>费用信息</p>
						</div>
						<div class="form_table_wrapper">
							<div class="form_table_add">
								<div class="form_table_add_block">
									<img src="../../assets/04@2x.png" @click="get_add_feiyong" />
									<p>新增费用</p>
								</div>
							</div>
							<div>
								<div class="form_th_wrapper">
									<div class="form_th_list">
										<div class="form_th_list_block">序号</div>
										<div class="form_th_list_block active">费用名称</div>
										<div class="form_th_list_block">数量</div>
										<div class="form_th_list_block">单价</div>
										<div class="form_th_list_block">金额</div>
										<div class="form_th_list_block">币制</div>
										<div class="form_th_list_block active">备注</div>
										<div class="form_th_list_block active">操作</div>
									</div>
									<div class="form_th_list" v-for="(item, index) in feiyong_list" :key="index">
										<div class="form_th_list_block">{{index + 1}}</div>
										<div class="form_th_list_block active" v-if="!item.is_save">
											<el-select v-model="item.name_id_name" filterable placeholder="请选择" @change="get_change(1, $event, index)">
												<el-option v-for="item in feiyong_name_list" :key="item.id" :label="item.name" :value="item"></el-option>
											</el-select>
										</div>
										<div class="form_th_list_block active" v-else>{{item.name_id_name}}</div>
										<div class="form_th_list_block" v-if="!item.is_save">
											<el-input placeholder="请输入数量" v-model="item.number"></el-input>
										</div>
										<div class="form_th_list_block" v-else>{{item.number}}</div>
										<div class="form_th_list_block" v-if="!item.is_save">
											<el-input placeholder="请输入单价" v-model="item.money"></el-input>
										</div>
										<div class="form_th_list_block" v-else>{{item.money}}</div>
										<div class="form_th_list_block" v-if="!item.is_save">
											<el-input placeholder="请输入金额" v-model="item.price"></el-input>
										</div>
										<div class="form_th_list_block" v-else>{{item.price}}</div>
										<div class="form_th_list_block" v-if="!item.is_save">
											<el-select v-model="item.currency_system_name" filterable placeholder="请选择" @change="get_change(2, $event, index)">
												<el-option v-for="item in currency_list" :key="item.value" :label="item.label" :value="item"></el-option>
											</el-select>
										</div>
										<div class="form_th_list_block" v-else>{{item.currency_system_name}}</div>
										<div class="form_th_list_block active" v-if="!item.is_save">
											<el-input placeholder="请输入备注" v-model="item.remark"></el-input>
										</div>
										<div class="form_th_list_block active" v-else>{{item.remark?item.remark: '-'}}</div>
										<div class="form_th_list_block operat active">
											<div class="c_5bbef0 pointer_" @click="get_resource_btn(item)">{{item.is_save?'编辑': '保存'}}</div>
											<div class="c_ff6f6f pointer_ m_l21" @click="get_resource_del(index, item)">删除</div>
										</div>
									</div>
								</div>
							</div>
							<div class="form_total">
								<div style="flex: 1;display: flex;flex-wrap: wrap;">
									<div class="form_total" v-if="item.id !== 7" v-for="(item, index) in hv" :key="index">
										<p>{{item.name}}*汇率：</p>
										<div class="form_total_input">
											<el-input placeholder="" v-model="item.hl"></el-input>
										</div>
									</div>
								</div>
								<div>
									<div class="form_total">
										<p>合计：</p>
										<div class="form_total_input">
											<el-input placeholder="" v-model="submit_info.total_price"></el-input>
										</div>
										<p>RMB</p>
									</div>
									<p class="c_ff6f6f hj_btn" style="margin-left: 67px;cursor: pointer;" @click="get_heji">点击获取合计数据</p>
								</div>
							</div>
							<!-- <div class="form_total">
								<p>合计：</p>
								<div class="form_total_input">
									<el-input placeholder="" v-model="submit_info.total_price"></el-input>
								</div>
								<p>RMB</p>
							</div> -->
						</div>
					</div>
				</div>
				<div class="form_wrapper_right form_wrapper_block order">
					<div class="p_lr30">
						<div class="form_wrapper_info">
							<p class="form_wrapper_info_title"><span class="c_ff6f6f">*</span>发货人信息:</p>
							<div>
								<el-input type="textarea" placeholder="请填写发货人信息" v-model="submit_info.shipper_info"></el-input>
							</div>
						</div>
						<div class="form_wrapper_info">
							<p class="form_wrapper_info_title"><span class="c_ff6f6f">*</span>收货人信息:</p>
							<div>
								<el-input type="textarea" placeholder="请填写收货人信息" v-model="submit_info.consignee_info"></el-input>
							</div>
						</div>
						<div class="form_wrapper_info">
							<p class="form_wrapper_info_title">唛头:</p>
							<div>
								<el-input type="textarea" placeholder="请填写唛头" v-model="submit_info.mark"></el-input>
							</div>
						</div>
						<div class="form_input_wrapper">
							<p class="form_input_label"><span class="c_ff6f6f">*</span>客户名称：</p>
							<div class="form_input">
								<v-select :icon_num="true" :list="kehu_list" :index="1" :value_name="submit_info.company_id_name" @result="get_kehu_serch"></v-select>
							</div>
						</div>
						<div class="form_input_wrapper">
							<p class="form_input_label"><span class="c_ff6f6f">*</span>联系人：</p>
							<div class="form_input">
								<v-select :icon_num="true" :list="lxr_list" :index="2" :value_name="submit_info.linkman_id_name" @result="get_kehu_serch"></v-select>
							</div>
						</div>
						<div class="form_input_wrapper">
							<p class="form_input_label"><span class="c_ff6f6f">*</span>联系电话：</p>
							<div class="form_input">
								<el-input v-model="submit_info.mobile" placeholder="请填写联系电话"></el-input>
							</div>
						</div>
						<div class="form_input_wrapper">
							<p class="form_input_label">联系邮箱：</p>
							<div class="form_input">
								<el-input v-model="submit_info.email" placeholder="请填写联系邮箱"></el-input>
							</div>
						</div>
						<div class="form_input_wrapper">
							<p class="form_input_label">结算账期:</p>
							<div class="form_input">
								<el-input v-model="submit_info.payment_days_name" placeholder="请填写联系邮箱" readonly=""></el-input>
								<!-- <v-select :icon_num="true" :list="zhangqi_list" :index="3" :value_name="submit_info.payment_days_name" @result="get_kehu_serch"></v-select> -->
							</div>
						</div>
						<div class="form_input_wrapper">
							<p class="form_input_label"><span class="c_ff6f6f">*</span>结算方式:</p>
							<div class="form_input">
								<v-select :icon_num="true" :list="fangshi_list" :index="4" :value_name="submit_info.pay_type_name" @result="get_kehu_serch"></v-select>
							</div>
						</div>
					</div>
					<!-- <div class="p_lr30 form_dynamic_wrapper">
						<div>最新动态：</div>
						<div>已签收<span class="m_l17">2021-02-05 10:00:00</span></div>
						<div class="form_dynamic_btn" @click="dialogVisible = true">查看</div>
					</div> -->
				</div>
			</div>
			<div class="form_wrapper">
				<div class="form_wrapper_block" style="width: 100%;">
					<div class="form_wrapper_btn_wrapper">
						<div class="btn01" @click="get_save_info(1)">保存</div>
						<div class="btn01" @click="$router.go(0)">重置</div>
						<div class="btn01" @click="get_save_info(2)">生成应收结算</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 弹窗 -->
		<el-dialog title=" " :show-close="false" :visible.sync="dialogVisible">
			<div class="pop-up_wrapper flex03 c_333">
				<div class="pop-up_left">
					<p class="font_16 flex04 bold_ pop-up_left_title">详情</p>
					<div class="pop-up_content">
						<div class="pop-up_list flex01 active">
							<div class="hid_ m_r8">
								<img src="../../assets/order/01@2x.png" />
							</div>
							<div class="font_14 flex01">
								<p class="">订单编号：</p>
								<p class="c_999">AI 2021012300000</p>
							</div>
						</div>
						<div class="pop-up_step">
							<div class="pop-up_list flex01">
								<div class="hid_ m_r8">
									<img src="../../assets/order/02@2x.png" />
								</div>
								<div class="font_14 flex01">
									<p class="">已签收：</p>
									<p class="c_999">2021-02-05 10:00:00</p>
								</div>
							</div>
							<div class="pop-up_line flex04">
								<p></p>
							</div>
						</div>
						<div class="pop-up_step">
							<div class="pop-up_list flex01">
								<div class="hid_ m_r8">
									<img src="../../assets/order/03@2x.png" />
								</div>
								<div class="font_14 flex01">
									<p class="">派送中：</p>
									<p class="c_999">2021-02-05 10:00:00</p>
								</div>
							</div>
							<div class="pop-up_line flex04">
								<p></p>
							</div>
						</div>
						<div class="pop-up_step">
							<div class="pop-up_list flex01">
								<div class="hid_ m_r8">
									<img src="../../assets/order/04@2x.png" />
								</div>
								<div class="font_14 flex01">
									<p class="">已清关：</p>
									<p class="c_999">2021-02-05 10:00:00</p>
								</div>
							</div>
							<div class="pop-up_line flex04">
								<p></p>
							</div>
						</div>
						<div class="pop-up_step">
							<div class="pop-up_list flex01">
								<div class="hid_ m_r8">
									<img src="../../assets/order/05@2x.png" />
								</div>
								<div class="font_14 flex01">
									<p class="">已到港：</p>
									<p class="c_999">2021-02-05 10:00:00</p>
								</div>
							</div>
							<div class="pop-up_line flex04">
								<p></p>
							</div>
						</div>
						<div class="pop-up_step">
							<div class="pop-up_list flex01">
								<div class="hid_ m_r8">
									<img src="../../assets/order/06@2x.png" />
								</div>
								<div class="font_14 flex01">
									<p class="">运输中：</p>
									<p class="c_999">2021-02-05 10:00:00</p>
								</div>
							</div>
							<div class="pop-up_line flex04">
								<p></p>
							</div>
						</div>
						<div class="pop-up_step">
							<div class="pop-up_list flex01">
								<div class="hid_ m_r8">
									<img src="../../assets/order/07@2x.png" />
								</div>
								<div class="font_14 flex01">
									<p class="">已入仓：</p>
									<p class="c_999">2021-02-05 10:00:00</p>
								</div>
							</div>
							<div class="pop-up_line flex04">
								<p></p>
							</div>
						</div>
					</div>
				</div>
				<div class="pop-up_right c_333">
					<div class="pop-up_step_wrapper hid_">
						<div class="pop-up_step_list flex04" :class="item.is_show == 1?'active': item.is_show == 2?'cannot': ''" v-for="(item, index) in wuliu_list"
						 :key="index">
							<i @click="get_wuliu(item)"></i>
							<p class="font_14">{{item.name}}</p>
						</div>
					</div>
					<div class="flex04 hid_">
						<p class="btn01 m_b30" @click="dialogVisible = false">保存</p>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import crumbs from '../../components/crumbs/index.vue'; // 面包屑
	import select05 from '../../components/select/index05.vue'; // 模糊查询

	import {
		circuit,
		tspMode,
		services,
		transport,
		getAllList,
		serviceType,
		startHarbor,
		endHarbor,
		hsCode,
		currency,
		costName,
		companyList,
		getAllLinkman,
		payDays,
		payType,
		orderAdd,
		orderCost,
		packing,
		companyDetail
	} from '@/api/index';

	export default {
		components: {
			'v-crumbs': crumbs,
			'v-select': select05
		},
		data() {
			return {
				pack_list: [],
				feiyong_all: 0,
				dialogVisible: false,
				kehu_list: [],
				hs_list: [],
				lxr_list: [],
				zhangqi_list: [],
				luxian_list: [],
				currency_list: [],
				fangshi_list: [],
				serve_list: [],
				company_list: [],
				transport_list: [],
				start_harbor_list: [],
				end_harbor_list: [],
				transportation_list: [],
				services_scope_list: [],
				feiyong_name_list: [],
				submit_info: {
					order_no: '', // 报价编号
					bidder: '', // 报价人员
					validity: '', // 报价有效期
					service_type_id: 0, // 服务类型
					service_type_id_name: '',
					services_scope_id: '', // 服务范围
					services_scope_id_name: '',
					transport_id: '', // 运输方式
					transport_id_name: '',
					transportation_id: '', // 运输流向
					transportation_id_name: '',
					circuit_id: '', // 线路
					circuit_id_name: '',
					shipping_company: '', // 航司/船司
					shipping_company_name: '',
					shipment_id: '', // 起运地/起运港
					shipment_id_name: '',
					destination_id: '', // 目的地/目的港
					destination_id_name: '',
					shipper_info: '', // 发货人信息
					consignee_info: '', // 收货人信息
					mark: '', // 唛头
					company_id: '', // 客户名称
					company_id_name: '',
					linkman_id: '', // 联系人
					linkman_id_name: '',
					mobile: '', // 联系电话
					email: '', // 邮箱
					payment_days: '', // 结算算账期
					payment_days_name: '',
					pay_type: '', // 结算方式
					pay_type_name: '',
					cargo: [], // 货物信息
					cost: [], // 费用信息		
					waybill_no: '',
					total_price: '', // 总计
					sales_person:'',//销售人员
				},
				huowu_list: [{
					cases: '', // 件数
					pack: '', // 包装
					rough_weight: '', // 毛重
					weight: '', // 计重
					long: '', // 长
					tall: '', // 高
					broad: '', // 宽
					bulk: '', // 体积
					chinese_name: '', // 中文品名
					english_name: '', // 英文品名
					hs_code: '', // HS编码
					hs_code_name: '',
					low_value: '', // 货值
					currency_system: '', // 币制
					currency_system_name: '',
					flight_name: '', // 船名/航次
					shipment_date: '' // 起运日期
				}], // 货物信息
				feiyong_list: [{
					is_save: false,
					name_id: '', // 费用名称
					name_id_name: '',
					number: '', // 数量
					money: '', // 单价
					currency_system: '', // 币制
					currency_system_name: '',
					remark: '', // 备注
					price: '' // 金额
				}],
				wuliu_list: [{
					name: '已签收',
					is_show: 0, // 0-未选中 1-选中 2-不可选
				}, {
					name: '派送中',
					is_show: 0, // 0-未选中 1-选中 2-不可选
				}, {
					name: '已清关',
					is_show: 0, // 0-未选中 1-选中 2-不可选
				}, {
					name: '已到港',
					is_show: 0, // 0-未选中 1-选中 2-不可选
				}, {
					name: '运输中',
					is_show: 0, // 0-未选中 1-选中 2-不可选
				}, {
					name: '已入仓',
					is_show: 0, // 0-未选中 1-选中 2-不可选
				}],
				hv: [],
			}
		},
		created() {
			this.get_serve_list();
			this.getServicesList();
			this.getTspModeList();
			this.getTransportList();
			// this.get_getAllList();
			this.get_luxian_list();
			// this.getStartHarborList();
			// this.getEndHarborList();
			// this.getHsCodeList();
			this.getCurrencyList();
			this.getCostNameList();
			this.getCompanyList();
			this.getPayDays();
			this.getPayTypeList();
			this.getPackingList();
		},
		watch: {
			huowu_list: {
				deep: true,
				handler(val) {
					// 体积重量（kg）= 件数*长*宽*高/6000;
					// 体积（cbm）= 体积重量/167;
					// 计重 = 毛重or体积重量，取最大值;
					let list_ = val;

					list_.forEach((n, k) => {
						if (n.long && n.broad && n.tall && n.cases) {
							n.tj = Number(n.cases) * Number(n.long) * Number(n.broad) * Number(n.tall) / 1000000; // 体积
							setTimeout(() => {
								n.bulk = Math.round(n.tj * 100) / 100;
							}, 300)
						} else {
							n.tj = '';
							n.bulk = '';
						}

						if (n.tj) {
							n.tj_zl = Number(n.tj) * 167;
						} else {
							n.tj_zl = '';
						}

						if (n.rough_weight && n.tj_zl) {
							n.jz = Number(n.rough_weight) > Number(n.tj_zl) ? n.rough_weight : n.tj_zl;
							
							// n.weight = Math.round(n.jz * 10) / 10;
							
							if (!n.bulk) {
								n.weight = Math.round(n.jz * 10) / 10;
							}
						} else {
							n.jz = '';
							// n.weight = '';
						}
					})
				}
			},
			feiyong_list: {
				deep: true,
				handler(val) {
					let list_ = val;
					let ids = [];
					let ids_list = [];
				
					this.hv = [];
				
					list_.forEach((n, k) => {
						if (n.money && n.number) {
							n.price = (Number(n.money) * Number(n.number)).toFixed(2);
						} else {
							n.price = '';
						}
				
						ids.push(n.currency_system_name);
						ids_list.push(n.currency_system);
					})
				
					let ids_name = [ids[0]]; //结果数组
					let ids_ = [ids_list[0]]; //结果数组
					//从第二项开始遍历
					for (var i = 1; i < ids.length; i++) {
						if (ids.indexOf(ids[i]) == i) ids_name.push(ids[i]);
						if (ids_list.indexOf(ids_list[i]) == i) ids_.push(ids_list[i]);
					}
				
					ids_name.forEach((n, k) => {
						if (n) {
							this.hv.push({
								name: n,
								hl: '1',
								id: ids_[k]
							})
						}
					})
				}
			}
		},
		methods: {
			// 合计
			get_heji() {
				let array = this.hv;
				let p_ = 0;
			
				array.forEach((n_, k_) => {
					array[k_].list = [];
					array[k_].price = 0
				})
			
				this.feiyong_list.forEach((n, k) => {
					array.forEach((n_, k_) => {
						if (n.currency_system == n_.id) {
							array[k_].list.push(n)
						}
					})
				})
			
				array.forEach((n_, k_) => {
					if (n_.list.length > 0) {
						n_.list.forEach((n, k) => {
							n_.price = n_.price + Number(n.price)
						})
					}
				})
			
				array.forEach((n_, k_) => {
					n_.price = ((n_.price.toFixed(2)) * n_.hl).toFixed(2);
			
					p_ = p_ + Number(n_.price);
				})
			
				this.submit_info.total_price = p_.toFixed(2);
			},
			// 包装列表
			getPackingList() {
				packing({
					page: 1,
					limit: 100000
				}).then(res => {
					let list_ = res.data.data;

					list_.forEach((n, k) => {
						this.pack_list.push({
							label: n.name,
							value: n.id
						})
					})
				})
			},
			get_pak(e) {
				this.huowu_list[e.index].pack = e.label;
			},
			// 服务类型
			get_serve_list() {
				serviceType({
					page: 1,
					limit: 100000
				}).then(res => {
					let list_ = res.data.data;

					list_.forEach((n, k) => {
						this.serve_list.push({
							label: n.name,
							value: n.id
						})
					})
				})
			},
			get_serve_type(e) {
				this.submit_info.service_type_id = e.value;
				this.submit_info.service_type_id_name = e.label;

				this.getStartHarborList();
				this.getEndHarborList();
				this.submit_info.shipment_id = '';
				this.submit_info.shipment_id_name = '';
				this.submit_info.destination_id = '';
				this.submit_info.destination_id_name = '';
			},
			// 服务范围
			getServicesList() {
				services({
					page: 1,
					limit: 100000
				}).then(res => {
					this.services_scope_list = res.data.data;
				})
			},
			// 运输方式
			getTspModeList() {
				tspMode({
					page: 1,
					limit: 100000
				}).then(res => {
					this.transport_list = res.data.data;
				})
			},
			// 运输流向
			getTransportList() {
				transport({
					page: 1,
					limit: 100000
				}).then(res => {
					this.transportation_list = res.data.data;
				})
			},
			// 获取船司/航司
			get_getAllList() {
				getAllList({
					page: 1,
					limit: 100000
				}).then(res => {
					let list_ = res.data;

					list_.forEach((n, k) => {
						this.company_list.push({
							label: n.ship_name,
							value: n.id
						})
					})
				})
			},
			get_ship(e) {
				this.submit_info.shipping_company = e.value;
				this.submit_info.shipping_company_name = e.label;
			},
			// 路线
			get_luxian_list() {
				circuit({
					page: 1,
					limit: 100000
				}).then(res => {
					let list_ = res.data.data;

					list_.forEach((n, k) => {
						this.luxian_list.push({
							label: n.name,
							value: n.id
						})
					})
				})
			},
			get_luxian(e) {
				this.submit_info.circuit_id = e.value;
				this.submit_info.circuit_id_name = e.label;
			},
			// 获取起运港列表
			getStartHarborList() {
				startHarbor({
					page: 1,
					limit: 100000,
					service_type: this.submit_info.service_type_id
				}).then(res => {
					let list_ = res.data.data;
					this.start_harbor_list = [];

					list_.forEach((n, k) => {
						this.start_harbor_list.push({
							label: n.name + '/' + n.code,
							value: n.id
						})
					})
				})
			},
			get_harbor(e) {
				this.submit_info.shipment_id = e.value;
				this.submit_info.shipment_id_name = e.label;
			},
			// 获取目的港列表
			getEndHarborList() {
				endHarbor({
					page: 1,
					limit: 100000,
					service_type: this.submit_info.service_type_id
				}).then(res => {
					let list_ = res.data.data;
					this.end_harbor_list = [];

					list_.forEach((n, k) => {
						this.end_harbor_list.push({
							label: n.name + '/' + n.code,
							value: n.id
						})
					})
				})
			},
			get_end_harbor(e) {
				this.submit_info.destination_id = e.value;
				this.submit_info.destination_id_name = e.label;
			},
			// 获取hs编码列表
			getHsCodeList() {
				hsCode({
					page: 1,
					limit: 100000
				}).then(res => {
					let list_ = res.data.data;

					list_.forEach((n, k) => {
						this.hs_list.push({
							label: n.code,
							value: n.id
						})
					})
				})
			},
			get_hs(e) {
				this.huowu_list[e.index].hs_code = e.value;
				this.huowu_list[e.index].hs_code_name = e.label;
			},
			// 获取币制列表
			getCurrencyList() {
				currency({
					page: 1,
					limit: 100000
				}).then(res => {
					let list_ = res.data.data;

					list_.forEach((n, k) => {
						this.currency_list.push({
							label: n.name,
							value: n.id
						})
					})
				})
			},
			get_currency(e) {
				this.huowu_list[e.index].currency_system = e.value;
				this.huowu_list[e.index].currency_system_name = e.label;
			},
			// 费用名称
			getCostNameList() {
				costName({
					page: 1,
					limit: 100000
				}).then(res => {
					res.data.data.forEach((n, k) => {
						n.name = n.name + '/' + n.english_name
					})

					this.feiyong_name_list = res.data.data;
				})
			},
			// 新增货物信息
			get_add_huowu() {
				let check_info = true;

				// this.huowu_list.forEach((n, k) => {
				// 	for (let i in n) {
				// 		if (!n[i] && i !== 'english_name') {
				// 			check_info = false;
				// 		}
				// 	}
				// })

				// if (!check_info) return this.$message('请完善现有货物信息再添加下一条吧！')

				this.huowu_list.push({
					cases: '', // 件数
					pack: '', // 包装
					rough_weight: '', // 毛重
					weight: '', // 计重
					long: '', // 长
					tall: '', // 高
					broad: '', // 宽
					bulk: '', // 体积
					chinese_name: '', // 中文品名
					english_name: '', // 英文品名
					hs_code: '', // HS编码
					hs_code_name: '',
					low_value: '', // 货值
					currency_system: '', // 币制
					currency_system_name: '',
					flight_name: '', // 船名/航次
					shipment_date: '' // 起运日期
				})
			},
			// 删除货物信息
			get_del_huowu(index) {
				if (this.huowu_list.length === 1) return this.$message.error('至少保留一条数据');
				this.huowu_list.splice(index, 1);
			},
			// 费用
			// 新增费用
			get_add_feiyong() {
				this.feiyong_list.push({
					is_save: false,
					name_id: '', // 费用名称
					name_id_name: '',
					number: '', // 数量
					money: '', // 单价
					currency_system: '', // 币制
					currency_system_name: '',
					remark: '', // 备注
					price: '' // 金额
				})
			},
			get_change(type, e, index) {
				// 费用名称
				if (type === 1) {
					this.feiyong_list[index].name_id = e.id;
					this.feiyong_list[index].name_id_name = e.name;
				}

				// 币制
				if (type === 2) {
					this.feiyong_list[index].currency_system = e.value;
					this.feiyong_list[index].currency_system_name = e.label;
				}
			},
			// 保存/编辑
			get_resource_btn(item) {
				for (let i in item) {
					if (!item[i] && i !== 'is_save' && i !== 'createtime_text' && i !== 'cost_name' && i !== 'createtime' && i !==
						'updatetime' && i !== 'is_delete') return this.$message('请将内容填写完整');
				}

				item.is_save = !item.is_save;

				if (item.is_save) {
					// 保存 计算金额
					this.feiyong_all = 0;

					this.get_all_price();
				}

				this.$forceUpdate();
			},
			// 删除
			get_resource_del(index, item) {
				if (this.feiyong_list.length === 1) return this.$message.error('至少保留一条数据');

				this.$confirm('确定删除吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					if (item.id) {
						// costInfoDelById({
						// 	id: item.id
						// }).then(res => {
						// 	this.info.order_cost.splice(index, 1);
						// 	this.get_all_price();
						// })
					} else {
						this.feiyong_list.splice(index, 1);
						this.get_all_price();
					}
				})
			},
			get_all_price() {
				if (this.feiyong_list.length !== 0) {
					this.feiyong_all = 0;

					this.feiyong_list.forEach((n, k) => {
						if (n.is_save) {
							this.feiyong_all += parseFloat(n.price)
						}
					})
				}
			},
			// 右侧
			// 客户名称
			getCompanyList() {
				companyList({
					page: 1,
					limit: 100000,
					partner_type: 2
				}).then(res => {
					let list_ = res.data.data;

					list_.forEach((n, k) => {
						this.kehu_list.push({
							label: n.company_name,
							value: n.id
						})
					})
				})
			},
			// 根据企业id 获取联系人
			get_linkman_list() {
				getAllLinkman({
					company_id: this.submit_info.company_id
				}).then(res => {
					let list_ = res.data;
					this.lxr_list = [];

					list_.forEach((n, k) => {
						this.lxr_list.push({
							label: n.username,
							value: n.id
						})
					})
				})
			},
			// 结算账期
			getPayDays() {
				payDays({
					page: 1,
					limit: 100000
				}).then(res => {
					let name_ = '';
					let list_ = res.data.data;
					
					list_.forEach((n, k) => {
						if (n.id == this.submit_info.payment_days) {
							name_ = n.name
						}
					
						this.zhangqi_list.push({
							label: n.name,
							value: n.id
						})
					})
					
					this.submit_info.payment_days_name = name_;
				})
			},
			// 结算方式
			getPayTypeList(ids) {
				payType({
					page: 1,
					limit: 100000
				}).then(res => {
					this.fangshi_list = [];
					let list_ = res.data.data;
					let ids_array = ids.split(',');
					
					list_.forEach((n, k) => {
						ids_array.forEach((n_, k_) => {
							if (n.id == n_) {
								n.is_show = true;
							}
						})
					})
					
					list_.forEach((n, k) => {
						if (n.is_show) {
							this.fangshi_list.push({
								label: n.name,
								value: n.id
							})
						}
					})
				})
			},
			// 根据客户名称查结算账期 结算方式
			// 详情数据
			get_detail() {
				companyDetail({
					id: this.submit_info.company_id
				}).then(res => {
					this.submit_info.payment_days = res.data.finance.payment_days;
			
					this.getPayDays();
					this.getPayTypeList(res.data.finance.pay_type);
				})
			},
			get_kehu_serch(e) {
				if (e.index === 1) {
					// 客户名称
					this.submit_info.company_id = e.value;
					this.submit_info.company_id_name = e.label;
					this.get_linkman_list();
					this.get_detail();
					this.submit_info.linkman_id = '';
					this.submit_info.linkman_id_name = '';
					this.submit_info.pay_type = '';
					this.submit_info.pay_type_name = '';
				}

				if (e.index === 2) {
					// 联系人
					this.submit_info.linkman_id = e.value;
					this.submit_info.linkman_id_name = e.label;
				}

				if (e.index === 3) {
					// 结算账期
					this.submit_info.payment_days = e.value;
					this.submit_info.payment_days_name = e.label;
				}

				if (e.index === 4) {
					this.submit_info.pay_type = e.value;
					this.submit_info.pay_type_name = e.label;
				}
			},
			// 保存
			get_save_info(index) {
				// for (let i in this.submit_info) {
				// 	if (!this.submit_info[i] && i !== 'cargo' && i !== 'cost' && i !== 'order_no' && i !== 'services_scope_id_name' &&
				// 		i !== 'transport_id_name' && i !== 'transportation_id_name') return this.$message('请将内容填写完整');
				// }

				if (this.huowu_list.length === 0) return this.$message('请填写货物信息');
				if (this.feiyong_list.length === 0) return this.$message('请填写费用信息');

				let check_info = true;

				// this.huowu_list.forEach((n, k) => {
				// 	for (let i in n) {
				// 		if (!n[i] && i !== 'english_name') {
				// 			check_info = false;
				// 		}
				// 	}
				// })

				if (!check_info) return this.$message('请完善货物信息');

				let cost_list = [];

				this.feiyong_list.forEach((n, k) => {
					if (n.is_save) {
						cost_list.push(n)
					}
				})

				if (cost_list.length === 0) return this.$message('请完善费用信息');

				this.submit_info.cargo = this.huowu_list;
				this.submit_info.cost = this.feiyong_list;
				
				if (this.hv.length > 0) {
					
					this.submit_info.rate = [];
					
					this.hv.forEach((n, k) => {
						this.submit_info.rate.push({
							rate_id: n.id,
							rate_name: n.name,
							input_id: n.hl
						})
					})
				}

				// 添加
				orderAdd(this.submit_info).then(res => {
					if (index == 1) {
						this.$message.success('添加成功！');
						this.$publicFun.get_link('/order/list', {});
					}

					if (index == 2) {
						// 生成应收结算
						orderCost({
							id: res.data.id
						}).then(res_ => {
							this.$message.success('生成成功！');
							this.$publicFun.get_link('/order/list', {});
						})
					}
				})
			},
			// 物流
			get_wuliu(item) {
				if (item.is_show == 2) return this.$message.warning('暂不可选');

				item.is_show = 1
			},
		}
	}
</script>

<style lang="less" scoped>
	.info_wrapper {
		padding: 12px 9px;
	}

	/deep/ input::-webkit-input-placeholder,
	/deep/ textarea::-webkit-input-placeholder {
		color: #5B8EF0;
	}

	/deep/ input::-moz-placeholder,
	/deep/ textarea::-webkit-input-placeholder {
		color: #5B8EF0;
	}

	/deep/ input:-moz-placeholder,
	/deep/ textarea::-webkit-input-placeholder {
		color: #5B8EF0;
	}

	/deep/ input:-ms-input-placeholder,
	/deep/ textarea::-webkit-input-placeholder {
		color: #5B8EF0;
	}

	.box01 {
		/deep/ .el-dialog__wrapper {
			display: flex;
			align-items: center;
			justify-content: center;
		}

		/deep/ .el-dialog {
			margin: 0;
			margin-top: 0 !important;
			width: 515px !important;
			border-radius: 8px;
		}

		/deep/ .el-dialog__header {
			padding: 0;
		}

		/deep/ .el-dialog__body {
			padding: 0;
		}
	}

	.pop-up_wrapper {
		.pop-up_left {
			flex: 1;

			.pop-up_left_title {
				height: 47px;
				border-bottom: 1px solid #E7E7E7;
			}

			.pop-up_content {
				padding-left: 52px;
				padding-top: 23px;
				padding-bottom: 40px;

				.pop-up_step {
					&:last-child {
						.pop-up_line {
							height: 0;
						}
					}
				}
			}
		}

		.pop-up_right {
			width: 180px;
			border-left: 1px solid #E7E7E7;

			.pop-up_step_list {
				margin: 20px 0;

				&:first-child {
					margin-top: 41px;
				}

				&:last-child {
					margin-bottom: 35px;
				}

				&.cannot {
					i {
						background-color: #f4f4f4;
					}

					color: #999;
				}

				&.active {
					i {
						border: none;
						background: url(../../assets/03@2x.png) no-repeat center;
						background-size: 100% 100%;
					}
				}

				i {
					width: 16px;
					height: 16px;
					display: block;
					border-radius: 50%;
					margin-right: 6px;
					cursor: pointer;
					box-sizing: border-box;
					border: 1px solid #979797;
				}
			}
		}

		.pop-up_list {
			&.active {
				margin-bottom: 17px;

				img {
					width: 16px;
					height: 16px;
					margin: 3px;
				}
			}

			img {
				width: 22px;
			}
		}

		.pop-up_line {
			width: 22px;
			height: 17px;

			p {
				height: 100%;
				border-left: 1px solid #B6B6B6;
			}
		}
	}
</style>
